export const ABS_MONTH_VIEW = 'resourceTimelineMonth';
export const ABS_SCROLL_MONTH_VIEW = 'resourceTimelineScrollMonth';
export const ABS_DAY_VIEW = 'resourceTimelineDay';

export const ABSENCE_BLOCK_POSITION_START = 'start';
export const ABSENCE_BLOCK_POSITION_MIDDLE = 'middle';
export const ABSENCE_BLOCK_POSITION_END = 'end';
export const ABSENCE_BLOCK_POSITION_SINGLE = 'single';
